import { render, staticRenderFns } from "./Dcf.vue?vue&type=template&id=2336b971&scoped=true&"
import script from "./Dcf.vue?vue&type=script&lang=js&"
export * from "./Dcf.vue?vue&type=script&lang=js&"
import style0 from "./Dcf.vue?vue&type=style&index=0&id=2336b971&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2336b971",
  null
  
)

export default component.exports